export const documentsDeps = [
  "view_all_documents", "create_all_documents", "edit_all_documents", "delete_all_documents",
  "share_all_documents", "download_all_documents", "copy_all_documents", "edit_pdf_documents",
  "link_documents", "document_approval", "client_edit", "mark_client_unknown", "perform_ocr",
  "add_task", "send_sms", "view_clients_documents_reports", "view_users_documents_reports", "assign_user", "unassign_user","combine_documents"
];

export const permissionDependencies = {
  view_documents: [
    "view_unprocessed_documents", "view_processed_documents", "view_client_unknown_documents",
    "view_requests", "view_all_assigned", "view_all_unassigned", "view_my_assigned",
    ...documentsDeps
  ],
  view_mailroom: [
    "view_documents", "view_incoming_emails", "view_incoming_faxes", "view_scanned_files",
    "view_unprocessed_documents", "view_processed_documents", "view_client_unknown_documents",
    "view_requests", "view_all_assigned", "view_all_unassigned", "view_my_assigned",
    ...documentsDeps
  ],
  view_unprocessed_documents: [
    "view_all_assigned", "view_all_unassigned", "view_my_assigned"
  ]
};

export const permissionCategories = [
  {
    name: "Mail Room",
    children: [
      { name: "All Documents", value: "view_documents" },
      { name: "Incoming Emails", value: "view_incoming_emails" },
      { name: "Incoming Faxes", value: "view_incoming_faxes" },
      { name: "Scanned Files", value: "view_scanned_files" },
    ]
  },
  {
    name: "All Documents",
    children: [
      { name: "Unprocessed Documents", value: "view_unprocessed_documents" },
      { name: "Processed Documents", value: "view_processed_documents" },
      { name: "Client Unknown Documents", value: "view_client_unknown_documents" },
      { name: "Document Requests", value: "view_requests" }
    ]
  },
  {
    name: "Unprocessed Documents",
    children: [
      { name: "All Assigned", value: "view_all_assigned" },
      { name: "All Unassigned", value: "view_all_unassigned" },
      { name: "My Assigned", value: "view_my_assigned" }
    ]
  },
  {
    name: "Documents",
    children: documentsDeps.map((perm) => ({
      name: perm.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase()),
      value: perm
    }))
  },
  {
    name: "Clients",
    children: [
      { name: "View Clients", value: "view_clients" },
      { name: "Edit Client", value: "edit_clients" },
      { name: "View Requested Documents", value: "view_requested_documents" },
      { name: "Request Documents", value: "request_documents" },
      { name: "Upload Documents", value: "upload_documents" },
      { name: "Approve Requested Documents", value: "approve_requested_documents" },
      { name: "Reject Requested Documents", value: "reject_requested_documents" },
      { name: "Download Requested Documents", value: "download_requested_documents" },
      { name: "Delete Requested Documents", value: "delete_requested_documents" },
      { name: "View Beneficiaries", value: "view_beneficiaries" },
    ]
  },
  {
    name: "Settings",
    children: [
      { name: "Users", value: "users" },
      { name: "Field Settings", value: "field_settings" },
      { name: "Document Requests", value: "requested_documents" },
      { name: "Email Templates", value: "email_templates" },
    ]
  },
  {
    name: "Users",
    children: [
      { name: "View Users", value: "view_users" },
      { name: "Create User", value: "create_users" },
      { name: "Edit User", value: "edit_users" },
      { name: "Delete User", value: "delete_users" },
    ]
  },
  {
    name: "Field Settings",
    children: [
      { name: "View Field Settings", value: "view_field_settings" },
      { name: "Create Field Setting", value: "create_field_settings" },
      { name: "Edit Field Setting", value: "edit_field_settings" },
      { name: "Delete Field Setting", value: "delete_field_settings" },
    ]
  },
  {
    name: "Email Templates",
    children: [
      { name: "View Email Templates", value: "view_email_templates" },
      { name: "Create Email Template", value: "create_email_templates" },
      { name: "Edit Email Template", value: "edit_email_templates" },
      { name: "Delete Email Template", value: "delete_email_templates" },
    ]
  },
  {
    name: "Document Requests",
    children: [
      { name: "View Document Requests", value: "view_document_requests" },
      { name: "Create Document Request", value: "create_document_requests" },
      { name: "Edit Document Request", value: "edit_document_requests" },
      { name: "Delete Document Request", value: "delete_document_requests" },
      { name: "Relink Document Request", value: "relink_document_request" },
    ]
  },
  {
    name: "Delete",
    children: [
      { name: "Users", value: "users_delete" },
      { name: "Documents", value: "documents_delete" },
    ]
  },
  {
    name: "Delete Users",
    children: [
      { name: "View Delete Users", value: "view_trash_users" },
      { name: "Permanent Delete Users", value: "delete_users_permanently" },
      { name: "Restore Users", value: "restore_users" },
    ]
  },
  {
    name: "Delete Documents",
    children: [
      { name: "View Delete Documents", value: "view_trash_documents" },
      { name: "Permanent Delete Documents", value: "delete_documents_permanently" },
      { name: "Restore Documents", value: "restore_documents" },
    ]
  }
];
